import { configureStore } from '@reduxjs/toolkit';
import componentsReducer from '../features/pageComponents/componentsSlice';
import selectedComponentReducer from '../features/selectedComponent/selectedComponentSlice';
import componentsRepoReducer from "../features/componentsRepo/componentsRepoSlice";
import screenReducer from "../features/screen/screenSlice";
import themesReducer from "../features/themes/themesSlice";
import activeThemeReducer from "../features/themes/activeThemeSlice";
import supportPluginsReducer from "../features/supportPlugins/supportPluginsSlice";
import configReducer from "../features/config/configSlice";
import activeAppbarReducer from "../features/globalComponents/activeAppbarSlice";
import activeNavbarReducer from "../features/globalComponents/activeNavbarSlice";
import activeDrawerReducer from "../features/globalComponents/activeDrawerSlice";
import appbarsRepoReducer from "../features/globalComponents/appbarsRepoSlice";
import navbarsRepoReducer from "../features/globalComponents/navbarsRepoSlice";
import drawersRepoReducer from "../features/globalComponents/drawersRepoSlice";
import onboardReducer from "../features/onboard/onboardSlice";
import viewModeReducer from "../features/preview/viewModeSlice";

export const store = configureStore({
    reducer: {
        components: componentsReducer,
        selectedComponent: selectedComponentReducer,
        componentsRepo: componentsRepoReducer,
        screens: screenReducer,
        themes: themesReducer,
        activeTheme: activeThemeReducer,
        supportPlugins: supportPluginsReducer,
        config: configReducer,
        activeAppbar: activeAppbarReducer,
        activeNavbar: activeNavbarReducer,
        activeDrawer: activeDrawerReducer,
        appbarsRepo: appbarsRepoReducer,
        navbarsRepo: navbarsRepoReducer,
        drawersRepo: drawersRepoReducer,
        onboard: onboardReducer,
        viewMode: viewModeReducer,
    },
});
